import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=53bbca84&scoped=true&"
import script from "./FormDetails.vue?vue&type=script&lang=js&"
export * from "./FormDetails.vue?vue&type=script&lang=js&"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=53bbca84&lang=scss&scoped=true&"
import style1 from "./FormDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bbca84",
  null
  
)

export default component.exports